const API_BASE_URL = process.env.NEXT_PUBLIC_API_BASE_URL || 'http://localhost:5000/api';
// console.log("API", API_BASE_URL)

export async function apiFetch<T>(endpoint: string, options?: RequestInit): Promise<T> {
  // Get token from sessionStorage or localStorage if available
  let token = null;
  if (typeof window !== 'undefined') {
    let stored = sessionStorage.getItem("authUser");
    if (!stored) {
      stored = localStorage.getItem("authUser");
    }
    if (stored) {
      try {
        token = JSON.parse(stored).token;
      } catch {}
    }
  }
  // Only set Content-Type if not FormData
  let headers: Record<string, string> = {};
  if (!(options && options.body instanceof FormData)) {
    headers['Content-Type'] = 'application/json';
  }
  if (options && options.headers && typeof options.headers === 'object' && !Array.isArray(options.headers)) {
    headers = Object.assign(headers, options.headers);
  }
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }
  const res = await fetch(`${API_BASE_URL}${endpoint}`, {
    ...options,
    headers,
    // credentials: 'include', // Removed because backend uses origin: '*' with credentials: false
  });
  if (!res.ok) {
    let errorMsg = 'Unknown error';
    try {
      const err = await res.json();
      errorMsg = err.message || err.error || errorMsg;
    } catch {}
    throw new Error(errorMsg);
  }
  return res.json();
} 